import { BoardContainer } from './BoardContainer';
import * as Anuto from "../../../../engine/src";
import { GameVars } from "../../../GameVars";
import { GameConstants } from "../../../GameConstants";
import { AudioManager } from "../../../AudioManager";

export class SuicideSoldierActor extends Phaser.GameObjects.Container {

    private anutoSuicideSoldier: Anuto.SuicideSoldier;
    private pigSprite: Phaser.GameObjects.Sprite;

    private f: number;
    private nextDynamite: number;

    private prevX: number;
    
    constructor(scene: Phaser.Scene, anutoSuicideSoldier: Anuto.SuicideSoldier) {

        super(scene);

        this.anutoSuicideSoldier = anutoSuicideSoldier;

        this.pigSprite = this.scene.add.sprite(0, 0, "texture_atlas_1", "explosive_pig_01");
        this.pigSprite.scaleX = -1;
        this.pigSprite.setOrigin(.5, .85);
        this.pigSprite.anims.play("pig_running");
        this.add(this.pigSprite);

        this.x = this.anutoSuicideSoldier.x * GameConstants.CELLS_SIZE;
        this.y = this.anutoSuicideSoldier.y * GameConstants.CELLS_SIZE;

        this.prevX = this.x;

        this.f = 0;
        this.nextDynamite = Math.round(Math.random() * 20 + 10);

        AudioManager.playSound("pig_running", true, 1, GameVars.timeStepFactor === 1 ? 1 : 1.5);
    }

    public update(time: number, delta: number): void {

        let smoothFactor: number;

        if (GameConstants.INTERPOLATE_TRAJECTORIES) {
            smoothFactor = GameVars.timeStepFactor === 1 ? .15 : .5;
        } else {
            smoothFactor = 1;
        }

        this.prevX = this.x;

        this.x += (this.anutoSuicideSoldier.x * GameConstants.CELLS_SIZE - this.x) * smoothFactor;
        this.y += (this.anutoSuicideSoldier.y * GameConstants.CELLS_SIZE - this.y + 10) * smoothFactor;

        if (this.prevX < this.x) {
            this.pigSprite.scaleX = 1;
        } else if (this.prevX > this.x) {
            this.pigSprite.scaleX = -1;
        }

        this.f++;

        if (this.f === this.nextDynamite) {
            this.f = 0;
            if (!GameVars.paused) {
                this.nextDynamite = Math.round(Math.random() * 20 + 10);
                BoardContainer.currentInstance.throwDynamite(this.x, this.y);
            }  
        }
    }

    public detonate(): void {

        this.pigSprite.visible = false;

        this.flare();

        let numExplosions = 10;
        let range = this.anutoSuicideSoldier.explosionRange * GameConstants.CELLS_SIZE;
        let count = 0;
        let delay = GameVars.timeStepFactor === 1 ? 40 : 10;

        const explosionEffect = this.scene.add.sprite(0, 0, "texture_atlas_3");
        explosionEffect.setScale(3);
        this.add(explosionEffect);

        explosionEffect.anims.play("explosion");
        AudioManager.playSound("explosion_max");

        explosionEffect.on("animationcomplete", () => {
            explosionEffect.destroy();        
        }, this);

        this.scene.cameras.main.shake(1000, 0.01);

        for (let i = 0; i < numExplosions; i++) {

            this.scene.time.addEvent({ delay: delay * i, callback: () => {
                const explosionEffect = this.scene.add.sprite(Math.random() * range - range / 2, Math.random() * range - range / 2, "texture_atlas_3");
                explosionEffect.setScale(Math.random() + 1);
                this.add(explosionEffect);

                explosionEffect.anims.play("explosion");
                AudioManager.playSound("explosion_max", false, 1, 1 - i * .05);

                explosionEffect.on("animationcomplete", () => {
                    count++;
                    explosionEffect.destroy();
                    if (count === numExplosions) {
                        this.destroy();
                    }         
                }, this);
            }, callbackScope: this});
        }
        

        if (GameConstants.SHOW_DEBUG_GEOMETRY) {
            const rangeGraphics = new Phaser.GameObjects.Graphics(this.scene);
            rangeGraphics.lineStyle(1, 0xFF0000);
            rangeGraphics.strokeCircle(0, 0, range);
            this.add(rangeGraphics);
        }
        
        AudioManager.stopSound("pig_running");
    }

    private flare(): void {

        let flare = new Phaser.GameObjects.Image(this.scene, 0, -20, "texture_atlas_1", "flare_orange");
        flare.alpha = 0;
        flare.setScale(0);
        this.add(flare);

        this.scene.tweens.add({
            targets: flare,
            alpha: 1,
            scaleX: 5,
            scaleY: 5,
            ease: Phaser.Math.Easing.Linear.Linear,
            duration: 200,
            onComplete: () => {

                this.scene.tweens.add({
                    targets: flare,
                    alpha: 0,
                    scaleX: 7,
                    scaleY: 7,
                    ease: Phaser.Math.Easing.Linear.Linear,
                    duration: 200,
                    onComplete: () => {
                        flare.destroy();
                    },
                    onCompleteScope: this
                });
            },
            onCompleteScope: this
        });
    }
}
